import axios from 'axios';

/**
 * Get statistics emails
 * @param {number} from
 * @param {number} until
 * @param {boolean} isWorkingHours
 * @returns {Promise<Object>}
 */
export function getStatisticsEmails(from, until, isWorkingHours) {
    return axios({
        method: 'POST',
        url: '/api/v1/statistics/emails',
        data: {
            from,
            until,
            isWorkingHours,
        },
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function getStatisticsEmailsReceived(from, until) {
    return axios({
        method: 'POST',
        url: '/api/v1/statistics/emails-received',
        data: {
            from,
            until,
        },
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}



// WEBPACK FOOTER //
// ./app/services/statistics/emails.js